import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Manifiesto from "@/components/Manifiesto";
import Programa from "@/components/Programa";
import Cronograma from "@/components/Cronograma";
import Autoras from "@/components/Autoras";
import ParaQuien from "@/components/ParaQuien";
import Testimonios from "@/components/Testimonios";
import SobreMi from "@/components/SobreMi";
import Inversion from "@/components/Inversion";
import Planes from "@/components/Planes";
import Postulacion from "@/components/Postulacion";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const hash = anchor.getAttribute("href");
      if (hash.length > 1) {
        const el = document.querySelector(hash);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -72, duration: 1.4 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="bg-ink font-sans text-cream antialiased" data-testid="app-root">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Manifiesto />
        <Programa />
        <Cronograma />
        <ParaQuien />
        <Testimonios />
        <Inversion />
        <Planes />
        <Postulacion />
        <Autoras />
        <SobreMi />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default App;
